/**
 * Regras do painel "Testar": as respostas que o composer monta para cada
 * tipo de pergunta, a máscara do telefone e os limites da data.
 */
import type { Prompt } from './types';

/** "11987654321" → "(11) 98765-4321" enquanto se digita (fixo: "(11) 3456-7890"). */
export function maskPhone(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  if (rest.length <= 4) return `(${ddd}) ${rest}`;
  const split = rest.length === 9 ? 5 : 4;
  return `(${ddd}) ${rest.slice(0, split)}-${rest.slice(split)}`;
}

function isoDay(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Limites do seletor de data: sem passado, mínimo hoje; sem futuro, máximo hoje. */
export function dateBounds(prompt: Pick<Prompt, 'allow_past' | 'allow_future'>, today = new Date()) {
  const day = isoDay(today);
  return { min: prompt.allow_past ? undefined : day, max: prompt.allow_future ? undefined : day };
}

/** A dica abaixo do campo de número ("Entre 1 e 10", "Número inteiro"). */
export function numberHint(prompt: Pick<Prompt, 'min' | 'max' | 'integer'>): string {
  const n = (v: number) => v.toLocaleString('pt-BR');
  const parts: string[] = [];
  if (prompt.min !== null && prompt.max !== null) parts.push(`Entre ${n(prompt.min)} e ${n(prompt.max)}`);
  else if (prompt.min !== null) parts.push(`A partir de ${n(prompt.min)}`);
  else if (prompt.max !== null) parts.push(`Até ${n(prompt.max)}`);
  if (prompt.integer) parts.push('número inteiro');
  const text = parts.join(', ');
  return text ? text[0]!.toUpperCase() + text.slice(1) : '';
}
